import { LoadingShimmer } from "@newsela/angelou";
import PropTypes from "prop-types";

import {
  rootCss,
  shimmerCss,
  contentVeilContainer,
  visuallyHiddenTextCss,
} from "./ContentVeil.style";

const propTypes = {
  visuallyHiddenText: PropTypes.string,
};

const ContentVeil = ({
  visuallyHiddenText = "This content isn't available for Newsela Lite.",
}) => {
  const contentVeilLines = new Array(5).fill(
    <LoadingShimmer
      __cssFor={{ root: rootCss, shimmer: shimmerCss }}
      suppressAnimation
    />,
  );
  return (
    <div css={contentVeilContainer} data-testid="content-veil">
      <div css={visuallyHiddenTextCss}>{visuallyHiddenText}</div>
      {contentVeilLines}
    </div>
  );
};

ContentVeil.propTypes = propTypes;

export default ContentVeil;
